import { FilterOrderRequest, FilterOrderResponse, postStyleFilterOrder } from '@/service/filter';
import { FilterGroup } from '@/service/type/Filter';
import { Filter } from '@/service/type/FilterDto';
import { create } from 'zustand';

export enum FilterLibraryStateEnum {
  Welcome = 'Welcome',
  Shop = 'Shop',
}

export interface GeneratorFilterStore {
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  currentState: FilterLibraryStateEnum;
  setCurrentState: (state: FilterLibraryStateEnum) => void;
  currentFilterGroup: FilterGroup | null;
  setCurrentFilterGroup: (filterGroup: FilterGroup | null) => void;
  currentFilterGroups: FilterGroup[];
  setCurrentFilterGroups: (filterGroups: FilterGroup[]) => void;
  currentStrength: number;
  setCurrentStrength: (strength: number) => void;
  showNewFilterButton: boolean;
  updateShowNewFilterButton: () => void;

  filterList: Filter[] | undefined;
  filterGroupList: FilterGroup[] | undefined;
  setFilterGroupList: (filterGroupList: FilterGroup[] | undefined) => void;
  filterListError: { errorMessage: string; code: number } | undefined;
  filterGroupListError: { errorMessage: string; code: number } | undefined;
  submitFilterOrder: (req: FilterOrderRequest) => Promise<FilterOrderResponse>;
}

export const useGeneratorFilterStore = create<GeneratorFilterStore>((set, get) => ({
  disabled: false,
  setDisabled: (disabled: boolean) => set({ disabled }),
  currentState: FilterLibraryStateEnum.Welcome,
  setCurrentState: (state: FilterLibraryStateEnum) => set({ currentState: state }),
  currentFilterGroup: null,
  setCurrentFilterGroup: (filterGroup: FilterGroup | null) =>
    set((state) => ({
      currentFilterGroup: filterGroup,
      showNewFilterButton: filterGroup === null,
    })),
  currentFilterGroups: [],
  setCurrentFilterGroups: (filterGroups: FilterGroup[]) => set({ currentFilterGroups: filterGroups }),
  currentStrength: 0,
  setCurrentStrength: (strength: number) => set({ currentStrength: strength }),
  showNewFilterButton: true,
  updateShowNewFilterButton: () =>
    set((state) => ({
      showNewFilterButton: state.currentFilterGroup === null,
    })),
  filterList: undefined,
  filterGroupList: undefined,
  setFilterGroupList: (filterGroupList: FilterGroup[] | undefined) => set({ filterGroupList }),
  filterListError: undefined,
  filterGroupListError: undefined,

  submitFilterOrder: async (req: FilterOrderRequest) => {
    const response = await postStyleFilterOrder(req);
    if (response.sessionUrl) {
      window.location.href = response.sessionUrl;
    }
    return response;
  },
}));
